import React, {useState} from 'react'
import {Button, Form, Input, message, Modal, Radio, Switch} from 'antd'
import {useRevalidator} from 'react-router-dom'
import {AuthError} from '@supabase/supabase-js'
import {instance as userService} from '../../services/UserService'

import {useIntl} from 'react-intl'
import {passwordRegexp} from './util'

export type SignUpFormProps = {
  setEmailSent: (isEmailSent: boolean) => void
}

export function SignUpForm(props: SignUpFormProps) {
  const [form] = Form.useForm()

  const [isSubmitting, setSubmitting] = useState(false)
  const revalidator = useRevalidator()
  const [messageApi, contextHolder] = message.useMessage()

  const intl = useIntl()

  const password1 = Form.useWatch('password1', form)
  const password2 = Form.useWatch('password2', form)

  const passwordsMatch = password1 === password2

  const validateMessages = {
    required: intl.formatMessage({id: 'fieldIsRequired'}, {field: '${label}'}),
    types: {
      email: intl.formatMessage({id: 'emailIsIncorrect'}),
    },
    pattern: {
      mismatch: intl.formatMessage({id: 'passwordValidation'}),
    },
  }

  return (
    <div>
      {contextHolder}

      <Form
        form={form}
        layout="vertical"
        style={{width: 500}}
        validateMessages={validateMessages}
        onFinish={async (formState) => {
          setSubmitting(true)
          let result: {success: boolean; error?: AuthError}
          const signUp = {
            email: formState.email,
            password1: formState.password1,
            password2: formState.password2,
          }
          setSubmitting(false)
          if (passwordsMatch) {
            result = await userService.signUpEmailPassword(signUp.email, signUp.password1)
            if (result.success) {
              revalidator.revalidate()
              props.setEmailSent(true)
            } else {
              messageApi.open({
                type: 'error',
                content: result.error?.message,
              })
            }
          }
        }}
      >
        <Form.Item
          name="email"
          label={intl.formatMessage({id: 'email'})}
          rules={[{required: true, type: 'email'}]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="password1"
          label={intl.formatMessage({id: 'password'})}
          rules={[{required: true, pattern: passwordRegexp}]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="password2"
          label={intl.formatMessage({id: 'repeatPassword'})}
          rules={[
            {required: true},
            {
              validator(_rule, value) {
                if (value !== password1) {
                  return Promise.reject(intl.formatMessage({id: 'passwordMismatch'}))
                }

                return Promise.resolve()
              },
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" size="large" type="primary" style={{width: '100%'}}>
            {intl.formatMessage({id: 'continue'})}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
